const moreBtns = document.querySelectorAll('.more')

if (moreBtns.length > 0) {
    moreBtns.forEach(element => {
        element.addEventListener('click', function() {
            ticketShowMore(this)
        })
    });
}

window.addEventListener('resize', function() {
    const activShowMore = document.querySelectorAll('.more-text.active')
    activShowMore.forEach(el => {
        const siblings = Array.from(el.parentNode.children)
        const moreText = siblings.find(item => item.classList.contains('more-text'))
        moreText.style.height = 'unset'
        moreText.style.height = `${moreText.scrollHeight}px`
    })


})

function ticketShowMore(thisEL) {
    const siblings = Array.from(thisEL.parentNode.children)
    const moreText = siblings.find(item => item.classList.contains('more-text'))

    thisEL.classList.toggle('active')

    if (thisEL.classList.contains('active')) {
        thisEL.children[0].textContent = 'Less info'
        moreText.style.height = `${moreText.scrollHeight}px`
        moreText.classList.add('active')

    } else {
        thisEL.children[0].textContent = 'More info'
        moreText.style.height = '0px'
        moreText.classList.remove('active')
    }
}

window.addEventListener('load', function() {
    window.onresize = addStickyPos()
})

window.addEventListener('resize', function() {
    addStickyPos()
});


function addStickyPos() {
    const dateWrapper = document.querySelectorAll('.new-ticket__wrapper__content__date')
    if (dateWrapper.length > 0) {
        dateWrapper.forEach(function(item) {
            if (item.scrollHeight > 500) {
                item.children[0].classList.add('sticky')
            }
        })
    }
}

const findMore = document.querySelectorAll('.new-ticket__more')
const closeModal = document.querySelector('.new-ticket__modal__content__wrapper__header__close')
const modal = document.querySelector('.new-ticket__modal')
const ticketNav = document.querySelector('.new-ticket__nav')
const navItems = document.querySelectorAll('.new-ticket__nav__item')
const ticketTabs = document.querySelectorAll('.new-ticket__tabs')

findMore.forEach(el => {
    el.addEventListener('click', function() {
        modal.classList.add('active')
        document.querySelector('.new-ticket__modal__content__wrapper__text__wrapper').innerHTML = this.parentNode.children[3].innerHTML
        document.querySelector('.new-ticket__modal__content__wrapper__header__title').innerText = this.parentNode.children[0].innerHTML
    })
})

if (modal) {
    closeModal.addEventListener('click', function() {
        modal.classList.remove('active')
    })
}


if (ticketNav) {
    const mainMenu = document.querySelector('.main-header__sticky-wrapper')
    const ticketDates = document.querySelectorAll('.new-ticket__wrapper__content__date__sticky')
    let addTop
    document.addEventListener('scroll', function() {
        if (mainMenu.classList.contains('is-active')) {
            ticketNav.style.top = `${mainMenu.offsetHeight}px`
            ticketDates.forEach(el => {
                addTop = ticketNav.offsetHeight + mainMenu.offsetHeight
                el.style.top = `${addTop}px`
            })
        } else {
            ticketNav.style.top = `0px`
            ticketDates.forEach(el => {
                addTop = ticketNav.offsetHeight + mainMenu.offsetHeight
                el.style.top = `${addTop}px`
            })
        }
    })
}

navItems.forEach(el => {
    el.addEventListener('click', function() {
        navItems.forEach(el => {
            el.classList.remove('active')
        })
        this.classList.add('active')
        if (this.dataset.tabOpen === 'all') {
            document.querySelectorAll('.new-ticket__tabs__devider').forEach(el => el.classList.add('active'))
            ticketTabs.forEach(el => {
                el.classList.add('active')
            })
        } else {
            ticketTabs.forEach(el => {
                document.querySelectorAll('.new-ticket__tabs__devider').forEach(el => el.classList.remove('active'))
                el.classList.remove('active')
            })
            document.querySelector('[data-tab="' + this.dataset.tabOpen + '"]').classList.add('active')
        }
    })
})